/* eslint-disable no-undef */
import { call, put, takeEvery } from "redux-saga/effects"

// Login Redux States
import { GET_LESSON } from "./actionTypes"
import { apiError, getLessonSuccess } from "./actions"

//Include Both Helper File with needed methods
import { getOneLesson } from "../../../helpers/backend_helper"

function* get(params) {
  try {
    const response = yield call(getOneLesson, params.payload.id)
    yield put(getLessonSuccess(response))
  } catch (error) {
    yield put(apiError(error))
  }
}

function* lessonGetSaga() {
  yield takeEvery(GET_LESSON, get)
}

export default lessonGetSaga
